export const hiddenpagedata = [
  { id: 1, name: "intro-form", form: "initialform" },
  { id: 2, name: "new-client-form", form: "clientintake" },
  { id: 3, name: "links", links: "full-linktree" },
  { id: 4, name: "feedback-form", form: "feedbackform" },
];
